import { DataTableColumnDef } from "@/components/molecules";
import { BookingDriverAssignmentLogData } from "../actions/types";

// Shown when the vehicle is flagged incorrect but no recognised reason code is
// available (e.g. an assigned-vs-current vehicle mismatch, which carries none).
export const VEHICLE_WARNING_FALLBACK = "Driver is not in the correct vehicle";

export const driverWarningTooltips = {
  // Typeahead (ChangeDriver/ChangeVehicle) fallback when the vehicle is flagged
  // incorrect but no specific reason code is returned. Deliberately does NOT say
  // "vehicle type", since the real reason may be capacity, category, etc.
  warning_vehicle_type_incorrect: "Driver's vehicle isn't suitable for this job.",
  warning_match_driver_declined_client: "Driver has specified a preference to not be paired with this particular client.",
  warning_match_client_declined_driver: "Client has asked not to be matched with this particular driver.",

  // Specific vehicle-fitness reasons — typeahead `metadata.warning_vehicle_type_errors`,
  // booking `metadata.vehicle_correct_errors`
  // (backend enum VehicleManager\Enum\VehicleCorrectErrorMessage). Only the
  // typeahead has these codes, so only its tooltip can be reason-specific.
  //
  // --- Active: emitted by both legacy and the current category-based dispatch ---
  NO_VEHICLE: "Driver has no vehicle to perform this job.",
  NOT_ASSIGNED_VEHICLE: "Driver hasn't assigned a vehicle for this job.",
  VEHICLE_CAPACITY_INCORRECT: "Driver's vehicle doesn't have enough passenger capacity for this job.",
  VEHICLE_CATEGORY_MISMATCH: "Driver's vehicle doesn't meet the vehicle category this job requires.",
  //
  // --- Legacy: only emitted when a vehicle type has no category assigned
  //     (pre category-based dispatch). These no longer show up on migrated
  //     operators; kept until the backend drops them. ---
  NOT_IN_ASSIGNED_CATEGORY: "Driver's vehicle isn't approved for the category this job requires.",
  VEHICLE_CLASS_INCORRECT: "Driver's vehicle isn't the class this job requires.",
  VEHICLE_TYPE_INCORRECT: "Driver is assigned to a different vehicle type than the job requires.",
  VEHICLE_AGE_INCORRECT: "Driver's vehicle is older than this job allows.",
  VEHICLE_RATING_INCORRECT: "Driver's vehicle rating is too low for this job.",
  VEHICLE_MODEL_INCORRECT: "Driver's vehicle isn't the make/model this job requires.",
  ENGINE_TYPE_INCORRECT: "Driver's vehicle engine type doesn't match this job's requirement.",
  VEHICLE_COLOR_INCORRECT: "Driver's vehicle colour isn't allowed for this job.",
};

export const driverErrorTooltips = {
  error_match_driver: {
    NOT_OWN_FLEET: "Driver must belong to your own fleet",
    EXT_SUPPLIER: "Network jobs may not be performed by drivers outside of the network",
    UNKNOWN: "This job is unable to accept this job",
  },
};

export const bookingDriverAssignmentColumns: DataTableColumnDef<BookingDriverAssignmentLogData>[] = [
  {
    header: "Date and Time",
    cell: (props) => props.row.original.dateTime,
    size: 140,
  },
  {
    header: "Modifier",
    size: 140,
    cell: (props) => props.row.original.modifier,
  },
  {
    header: "Event",
    size: 220,
    cell: (props) => props.row.original.event,
  },
  {
    header: "Action",
    enableSorting: false,
    cell: (props) => <div className="line-clamp-3">{props.row.original.action}</div>,
  },
];
